import { useCallback } from 'react';
import { useLocale } from '@/i18n/LocaleProvider';
import { localized, fullName } from '@/lib/format';
import type { Bilingual, Profile } from '@/types/domain';

/** Helpers for rendering bilingual domain content in the active locale. */
export function useLocalized() {
  const { locale } = useLocale();
  const L = useCallback((value: Bilingual) => localized(value, locale), [locale]);
  const name = useCallback((p: Profile) => fullName(p, locale), [locale]);
  return { locale, L, name };
}
